import { Component, ElementRef, HostListener, Input, OnInit, ViewChild, SimpleChanges, OnChanges, ViewChildren, QueryList, AfterViewInit } from '@angular/core';
import * as moment from 'moment';
import 'chartjs-adapter-moment';
import { RentalKPI, DateValue, DateChartData, ChartData, ChartConfig, ComponentBase } from 't4core';
import { MdbChartDirective } from 'mdb-angular-ui-kit/charts'


@Component({
  selector: 't4-chart',
  templateUrl: './t4-chart.component.html',
  styleUrls: ['./t4-chart.component.css']
})
export class T4ChartComponent extends ComponentBase implements AfterViewInit, OnChanges {

  @Input() title: string = "";
  @Input() type: string = "line";
  @Input() orientation: string = "vertical";
  @Input() fillGaps: boolean = false;


  @Input() fromDate: moment.Moment = moment().startOf('month');
  @Input() toDate: moment.Moment = moment().endOf('month');
  @Input() diagramIds: string[] = [];
  @Input() dataId: any = null;

  @Input() unit: string = "week";
  @ViewChild(MdbChartDirective) diagram !: MdbChartDirective;

  public datasets: Array<any> = [{
    yAxisID: "y-axis-0", data: [0], label: "" }];
  public datasetsEmpty: Array<any> = [{
    yAxisID: "y-axis-0", data: [0] }];

  public barDatasets: Array<any> = [
      { data: [0], label: 'Bar chart' }
  ];

  //@HostListener('window:resize', ['$event'])
  //onResize(event) {
  //   this.flexFont();
  //}

  @ViewChild("Panel") public panel: ElementRef;
  public autoFontSize: string = 'auto';

  @Input() public Value: number = 0;
  @Input() public RelatedValue: number = 0;
  @Input() public Delta: number = 0;

  public isLoading: boolean = false;

  public labels = [];
  public chartColors: Array<any> = [
    { // Main
      backgroundColor: 'rgba(151,187,205,0.2)',
      borderColor: 'rgba(151,187,205,1)',
      borderWidth: 2,
      pointBackgroundColor: 'rgba(151,187,205,0)',
      pointBorderColor: 'rgba(0,0,0,0)',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(151,187,205,1)'
    },
    { // Light blue
      backgroundColor: 'rgba(151,187,205,0)',
      borderColor: 'rgba(151,187,205,0.5)',
      borderWidth: 2,
      pointBackgroundColor: 'rgba(151,187,205,0)',
      pointBorderColor: 'rgba(0,0,0,0)',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(151,187,205,0.5)'
    },
    { // Gray
      backgroundColor: 'rgba(151,187,205,0)',
      borderColor: 'rgba(175,175,175,1.0)',
      borderWidth: 2,
      pointBackgroundColor: 'rgba(151,187,205,0)',
      pointBorderColor: 'rgba(0,0,0,0)',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(175,175,175,0.5)'
    },
    { // Green
      backgroundColor: 'rgba(151,187,205,0)',
      borderColor: 'rgba(27,117,50,0.2)',
      borderWidth: 2,
      pointBackgroundColor: 'rgba(151,187,205,0)',
      pointBorderColor: 'rgba(0,0,0,0)',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(27,117,50,0.2)'
    },
    { // Red
      backgroundColor: 'rgba(205,151,151,0)',
      borderColor: 'rgba(205,151,151,0.5)',
      borderWidth: 2,
      pointBackgroundColor: 'rgba(0,0,0,0)',
      pointBorderColor: 'rgba(0,0,0,0)',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(0,0,0,0)'
    }
  ];
  public chartOptions: any = {
    responsive: true,
    scales: {
      y: {
        ticks: {
            display: false
          }
      },
      x: {
        type: 'time',
        time: {
          format: 'YYYY-MM-DD',
          unit: this.unit,
          unitStepSize: 1,
          bounds: 'data',
          tooltipFormat: 'ddd D/M [v]w',
          displayFormats: {
            week: '[v]W'
          }
        }
      }
    }
  };


    public barChartOptions: any = {
        responsive: true,
      scales: {
        y: {},
        x: {
          position: 'top',
          barPercentage: 1.0,
          categoryPercentage: 0.55
        }
      },
      options: {
        indexAxis: 'x',
      },
      backgroundColor: [
        'rgba(255, 99, 132, 0.2)',
        'rgba(54, 162, 235, 0.2)',
        'rgba(255, 206, 86, 0.2)',
        'rgba(75, 192, 192, 0.2)',
        'rgba(153, 102, 255, 0.2)',
        'rgba(255, 159, 64, 0.2)'
      ],
      borderColor: [
        'rgba(255,99,132,1)',
        'rgba(54, 162, 235, 1)',
        'rgba(255, 206, 86, 1)',
        'rgba(75, 192, 192, 1)',
        'rgba(153, 102, 255, 1)',
        'rgba(255, 159, 64, 1)'
      ],
    };

  public datasetCounter: number = 0; 
  public colorIndex: number = 0; 

  constructor() {
    super();
  }

  private isInitializing: boolean = true;
    public async ngAfterViewInit() {

    this.load();

    this.isInitializing = false;
  }


  ngOnChanges(changes: SimpleChanges) {
    if (this.isInitializing || changes.title && changes.title.previousValue == "") return;

    this.load(false);
    }

    public async load(firstLoad = true) {
        if (this.type == "line") {
            await this.loadLineChartData(firstLoad);
        }
        else if (this.type == "bar" || this.type == "horizontalBar") {
            await this.loadBarChartData();
        }
    }

  private async loadLineChartData(firstLoad = true) {
    if (!this.diagramIds.length) return;
    this.isLoading = true;
    this.datasetCounter = 0;
    this.colorIndex = 0;    

    var promises: Promise<number>[] = [];
    var results = [];
    for (let diagramId of this.diagramIds) {
        promises.push(this.Api.get<DateChartData>("Data/GetDiagramDateData", { diagramId: diagramId[0], from: this.fromDate, to: this.toDate, dataId: this.dataId ? this.dataId : null, fillGaps: this.fillGaps }).then(x => results.push({ Diagram: diagramId[0], Data: x })));
    }

    await Promise.all(promises);

    for (let diagramId of this.diagramIds) {
      var data = results.find(x => x.Diagram == diagramId[0]);

      //Y-axis settings
      if (!this.chartOptions.scales.y[diagramId[1]]) {
        this.chartOptions.scales.y =
        {
          stacked: false,
          position: ((this.chartOptions.scales.y.length) % 2 == 0) ? "left" : "right",
          id: diagramId[1],
          ticks: {
            suggestedMin: data.Data.Config.SuggestedMin,
            suggestedMax: data.Data.Config.SuggestedMax,
          }
        };
      }
      else {
        if (this.chartOptions.scales.y[diagramId[1]].ticks.suggestedMin > data.Data.Config.SuggestedMin)
          this.chartOptions.scales.y[diagramId[1]].ticks.suggestedMin = data.Data.Config.SuggestedMin;
        if (this.chartOptions.scales.y[diagramId[1]].ticks.suggestedMax < data.Data.Config.SuggestedMax)
          this.chartOptions.scales.y[diagramId[1]].ticks.suggestedMax = data.Data.Config.SuggestedMax;
        }

        //X-axis settings
        this.chartOptions.scales.x.time.unit = data.Data.Config.Unit;

        //Dataset
        await this.AddDateDataset(data.Data.ChartSeries[0], "Turbo.Core.Chart." + data.Diagram + ".Series" + 1, diagramId[1], firstLoad, false, data.Data.Config);

        //Related dataset
        if (data.Data.ChartSeries[1].length) {
            await this.AddDateDataset(data.Data.ChartSeries[1], "Turbo.Core.Chart." + data.Diagram + ".Series" + 2, diagramId[1], firstLoad, true, data.Data.Config);
        }
    }

    this.chartOptions.scales.x.time.min = this.fromDate.format("YYYY-MM-DD");
    this.chartOptions.scales.x.time.max = this.toDate.format("YYYY-MM-DD");

    this.diagram.update();
    this.isLoading = false;

    }

  public async AddDateDataset(dataset: DateValue[], label: string, yAxisId: string, firstLoad: boolean, relatedDataset, config: any) {

    var translatedLabel = await this.Translate.translate(label);

    //if (config.ColorSettings && config.ColorSettings.BackgroundColor) this.chartColors[this.datasetCounter].backgroundColor = config.ColorSettings.BackgroundColor;
    //if (config.ColorSettings && config.ColorSettings.BorderColor) this.chartColors[this.datasetCounter].borderColor = config.ColorSettings.BorderColor;

    this.datasets[this.datasetCounter] = {
      yAxisID: yAxisId,
      data: dataset,
      label: translatedLabel,
      borderDash: relatedDataset ? [10, 5] : [0, 0],
      tension: 0.4
    };

    if (relatedDataset && this.colorIndex > 0) this.colorIndex--;


    var colors = this.chartColors[this.colorIndex];

      this.datasets[this.datasetCounter].backgroundColor = colors.backgroundColor;
      this.datasets[this.datasetCounter].borderColor = colors.borderColor;
      this.datasets[this.datasetCounter].pointBorderColor = colors.pointBorderColor;
      this.datasets[this.datasetCounter].pointBackgroundColor = colors.pointBackgroundColor;

    this.datasetCounter++;
    this.colorIndex++;
    if (this.colorIndex > this.chartColors.length) this.colorIndex = 0;    
  }

  public async AddDataset(dataset: number[], label: string, yAxisId: string, firstLoad: boolean, relatedDataset = false) {

    var translatedLabel = await this.Translate.translate(label);

    this.datasets[this.datasetCounter] = {
      yAxisID: yAxisId,
      data: dataset,
      label: translatedLabel,
      borderDash: relatedDataset ? [10, 5] : [0, 0]
    };

    if (relatedDataset && firstLoad) {
      var colors = { ...this.chartColors[this.datasetCounter - 1] };
      colors.backgroundColor = 'rgba(205, 151, 151, 0)';
      this.chartColors.splice(this.datasetCounter, 0, colors);

      //this.datasets[this.datasetCounter].backgroundColor = colors.backgroundColor;
      //this.datasets[this.datasetCounter].borderColor = colors.borderColor;
      //this.datasets[this.datasetCounter].pointBackgroundColor = colors.pointBackgroundColor;
      //this.datasets[this.datasetCounter].pointBorderColor = colors.pointBackgroundColor;
      //this.datasets[this.datasetCounter].pointHoverBackgroundColor = colors.pointHoverBackgroundColor;
      //this.datasets[this.datasetCounter].pointHoverBorderColor = colors.pointHoverBorderColor;
    }

    
    this.datasetCounter++;

    }

    public async loadBarChartData() {
      this.isLoading = true;
      this.datasetCounter = 0;
      if (this.type == "bar") {
         
        if (this.orientation == "horizontal") {
          this.barChartOptions.options.indexAxis = 'y';
        }

            this.chartOptions = this.barChartOptions;        
            var promises: Promise<number>[] = [];
            var results = [];
            for (let diagramId of this.diagramIds) {
                promises.push(this.Api.get<ChartData>("Data/GetDiagramData", { diagramId: diagramId[0], from: this.fromDate, to: this.toDate }).then(x => results.push({ Diagram: diagramId[0], Data: x })));
            }
            await Promise.all(promises);

            this.labels = [];
            if (results[0] && results[0].Data.Config.ColorSettings.UseSameBackground == true) {
                this.chartColors = [
                    {
                        backgroundColor: results[0].Data.Config.ColorSettings.BackgroundColor,
                        borderColor: results[0].Data.Config.ColorSettings.BorderColor,
                        borderWidth: 2,
                        pointBackgroundColor: 'rgba(151,187,205,0)',
                        pointBorderColor: 'rgba(0,0,0,0)',
                        pointHoverBackgroundColor: '#fff',
                        pointHoverBorderColor: 'rgba(151,187,205,1)'
                    }
                ];
            }

            this.chartOptions = {
              responsive: true,
              indexAxis: 'y',
                scales: {
                  y: {},
                  x: {}
                }
            };


            for (let r of results) {

                var yAxis = {
                    id: r.Data.Config.YAxisId,
                  ticks: {
                        display: true,
                        suggestedMin: r.Data.Config.SuggestedMin,
                        suggestedMax: r.Data.Config.SuggestedMax,
                    }
              };
              this.chartOptions.scales.y = yAxis;
               //this.chartOptions.scales.y.push(yAxis);

                var xAxis = {
                    position: 'top',
                    barPercentage: 1.0,
                    categoryPercentage: 0.55
              };
              this.chartOptions.scales.x = xAxis;
               // this.chartOptions.scales.x.push(xAxis);

                var chartData = [];

                for (let l of r.Data.Labels) {
                    this.labels.push(l);
                }

                for (let c of r.Data.ChartSeries[0]) {
                    chartData.push(c);
                }

            this.addBarDataset(chartData, results[0].Diagram);

            //Related dataset
                if (r.Data.ChartSeries.length > 1 && r.Data.ChartSeries[1] && r.Data.ChartSeries[1].length > 0) {
                  var relatedChartData = [];
                  for (let c of r.Data.ChartSeries[1]) {
                      relatedChartData.push(c);
                  }
                  this.addBarDataset(relatedChartData, r.Diagram, true);
               }
        }        
        }

        this.isLoading = false;
    }

    public async addBarDataset(chartData, label, isRelatedDataset = false) {

      var totalAmount = 0;
      if (isRelatedDataset && this.colorIndex > 0) this.colorIndex--;
      var colors = this.chartColors[this.colorIndex];
        for (let c of chartData) {
            totalAmount = totalAmount + c;
        }

        if (!isRelatedDataset) {
            var d: Array<any> = [{ data: chartData, label: await this.Translate.translate("Turbo.Core.Chart." + label + ".Series" + 1) + ' (Total: ' + totalAmount.toFixed(2) + ')',  }];
            this.datasets = d;
        }
        else {
            var r: any = { data: chartData, label: await this.Translate.translate("Turbo.Core.Chart." + label + ".Series" + 2) + ' (Total: ' + totalAmount.toFixed(2)  + ')' };
            this.datasets.push(r);
      }

      this.datasets[this.datasetCounter].backgroundColor = colors.backgroundColor;
      this.datasets[this.datasetCounter].borderColor = colors.borderColor;
      this.datasets[this.datasetCounter].pointBorderColor = colors.pointBorderColor;
      this.datasets[this.datasetCounter].pointBackgroundColor = colors.pointBackgroundColor;

      this.datasetCounter++;
      this.colorIndex++;
      if (this.colorIndex > this.chartColors.length) this.colorIndex = 0;
      
    }

}
